$(document).ready(function () {
  
  $(document).on('click', '.header-nav__icon', function(){
    $('body').toggleClass('nav-opened');
    $(this).toggleClass('active');
    
    if ($('#nav-drawer-level-1').hasClass('show')) {
      $('.drawer-menu-list').css('height', $('#nav-drawer-level-1').innerHeight());
    }
  });
  
  $(document).on('click', '.drawer-menu-toggle', function(event){
    event.preventDefault();
    let targetId = $(this).data('target');
    let targetNav = $(this).data('nav');
    
   	let regExp = /level-\d/;
    let regExpString = $('.header__drawer-menu').attr('class');
    let regExpResult = regExp.exec(regExpString);
    
    if (regExpResult != null) {
      $('.header__drawer-menu').removeClass(`show-${regExpResult[0]}`);
    }

    $('.header__drawer-menu').addClass(`show-${targetNav}`);
    $('.drawer-menu-list').css('height', $(`#nav-${targetId}`).innerHeight());
    $(`#nav-${targetId}`).addClass('show').siblings('.list-menu').removeClass('show');
  });
  
  rootCss();
  $(window).resize(function (){
    rootCss();
  });
});

function rootCss() {
  let viewportHeight = $(window).height();
  let headerHeight = $('#shopify-section-header').height();
  
  $(':root').css({ 
    '--viewportHeight': viewportHeight+'px',
    '--headerHeight': Math.ceil(headerHeight)+'px'
  });
}